import React from "react";

import tr_assist_hakkimizda from "../img/tr_assist_hakkimizda.jpeg";

export const About = (props) => {
  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="about-image">
              <img 
                src={tr_assist_hakkimizda} 
                className="img-responsive about-img" 
                alt="TR Assist yol yardım hizmetleri - Profesyonel ekip ve modern araç filosu" 
                onError={(e) => {
                  e.target.style.display = 'block';
                  e.target.style.background = '#f0f0f0';
                }}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Hakkımızda</h2>
              <p>{props.data ? props.data.paragraph : "TR Assist olarak, Türkiye'nin önde gelen yol yardım ve ikame araç hizmet sağlayıcısıyız."}</p>
              <h3>Neden TR Assist?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
